import {
  CREATE_ACCOUNT_DROPDOWN,
  LOGOUT_DROPDOWN,
  NAV_HAMBURGER,
  SIGN_IN_DROPDOWN,
} from '@src/utils/dataTestIds'
import * as React from 'react'
import EmailAndLogout from '../EmailAndLogout'
import SignupAndLogin from '../SignupAndLogin'
import * as Styles from './styles'
import * as Types from './types'

const LoggedOutOptions = (props: Types.AccountMenuProps) => (
  <React.Fragment>
    <Styles.AccountMenuItem onClick={props.signUp}>
      <Styles.AccountMenuItemLink data-test={CREATE_ACCOUNT_DROPDOWN}>
        Create account
      </Styles.AccountMenuItemLink>
    </Styles.AccountMenuItem>
    <Styles.AccountMenuItem onClick={props.signIn}>
      <Styles.AccountMenuItemLink data-test={SIGN_IN_DROPDOWN}>
        Sign In
      </Styles.AccountMenuItemLink>
    </Styles.AccountMenuItem>
  </React.Fragment>
)

const LoggedInOptions: React.FunctionComponent<Types.LoggedInOptionsProps> = props => {
  return (
    <React.Fragment>
      <Styles.AccountMenuItem>
        <Styles.AccountMenuItemRouterLink to="/papers">
          My papers
        </Styles.AccountMenuItemRouterLink>
      </Styles.AccountMenuItem>
      <Styles.AccountMenuItem>
        <Styles.AccountMenuItemLink href={props.accountUrl}>
          My Account
        </Styles.AccountMenuItemLink>
      </Styles.AccountMenuItem>
      <Styles.AccountMenuItem onClick={props.logOut}>
        <Styles.AccountMenuItemLink data-test={LOGOUT_DROPDOWN}>
          Logout
        </Styles.AccountMenuItemLink>
      </Styles.AccountMenuItem>
    </React.Fragment>
  )
}

const AccountOptions = (props: Types.AccountOptionsProps) => (
  <Styles.Menu site={props.site}>
    {!props.loggedIn && <LoggedOutOptions {...props} />}
    {props.loggedIn && <LoggedInOptions {...props} />}
  </Styles.Menu>
)

export const InlineAccountMenu = (props: Types.AccountMenuProps) => {
  return (
    <Styles.AccountLinks site={props.site}>
      {props.loggedIn ? (
        <EmailAndLogout site={props.site} />
      ) : (
        <SignupAndLogin site={props.site} />
      )}
    </Styles.AccountLinks>
  )
}

export class DropDownAccountMenu extends React.Component<Types.DropDownMenuProps> {
  public state: Types.DropDownLocalState = {
    open: false,
  }

  public onHamburgerClick = () => this.setState({ open: !this.state.open })

  public onMouseOut = () => this.setState({ open: false })

  public render() {
    const { loggedIn, site, signUp, signIn, logOut, accountUrl } = this.props

    return (
      <Styles.AccountDropDown onMouseLeave={this.onMouseOut} site={site}>
        <Styles.AccountHamburger
          disabled={false}
          site={site}
          data-test={NAV_HAMBURGER}
          onClick={this.onHamburgerClick}
          aria-label="open account menu"
        />
        {this.state.open && (
          <AccountOptions
            site={site}
            signIn={signIn}
            signUp={signUp}
            logOut={logOut}
            loggedIn={loggedIn}
            accountUrl={accountUrl}
          />
        )}
      </Styles.AccountDropDown>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/AccountMenu/index.tsx